module.exports = __webpack_public_path__ + "static/img/profile_bg.9f7adcef.svg";